<template>
    <div class="page">
        <div class="page_content">
           <div class="top">
               <div class="top_textbox" data-aos="fade-down" data-aos-duration="500">
                    <div class="top_title">{{text.title[lang]}}</div>
                    <div class="line_bg">
                        <div class="line_anim" id="line_anim"></div>
                    </div>
                    <ul class="top_timeline">
                        <li>{{text.timeline[timelineIndex].title[lang]}}</li>
                        <li>{{text.timeline[timelineIndex].content[lang]}}</li>
                    </ul>
               </div> 
            </div>
            <div class="middle">
                <div class="midlle_part" v-for="(item, index) in text.midpart1" :key="index">
                    <div class="midlle_part_img" data-aos="fade-down" data-aos-duration="500">
                        <img class="img_base" :src="item.img" alt="">
                    </div>
                    <div class="middle_part_textbox" data-aos="fade-down" data-aos-duration="600" >
                        <div class="middle_part_title">{{item.title[lang]}}</div>
                        <div class="middle_part_content">{{item.content[lang]}}</div>
                    </div>
                </div>
            </div>
            <div class="middle2" data-aos="fade-down" data-aos-duration="600">
                <div class="middle2_topbox">
                    <div class="middle2_topitem" v-for="(item, index) in text.midpart2" :key="index">
                        <div class="middle2_title">{{item.title[lang]}}</div>
                        <div class="line2_box">
                            <div class="line2_anim" :id="'line2_anim_' + index " v-show="index === midIndex2" ></div>
                        </div>
                        
                    </div>
                </div>
                <div class="middle2_text">{{text.midpart2[midIndex2].content[lang]}}</div>
                <router-link to="/about-social-resposibility" style="text-decoration: none;" >
                    <div class="middle2_button">{{lang === 0 ? '社会责任 >>' : 'social resposibility >>'}}</div>
                </router-link>
            </div>
            <div class="middle">
                <div class="midlle_part" v-for="(item, index) in text.midpart3" :key="index">
                    <div class="midlle_part_img" data-aos="fade-down" data-aos-duration="500">
                        <img class="img_base" :src="item.img" alt="">
                    </div>
                    <div class="middle_part_textbox" data-aos="fade-down" data-aos-duration="600">
                        <div class="middle_part_title">{{item.title[lang]}}</div>
                        <div class="middle_part_content">{{item.content[lang]}}</div>
                    </div>
                </div>
            </div>
        </div>
        <Foot/>
        <Nav></Nav>
    </div>
</template>

<script>
import Nav from '@/components/Nav.vue'
import Foot from '@/components/Foot.vue'
import {overviewText} from '@/js/text.js'
import {wxShare} from '@/js/api.js'
export default {
    components: {
        Nav,
        Foot
    },
    data () {
        return {
            text: overviewText,
            timelineIndex: 0,
            midIndex2: 0
        }
    },
    computed: {
        lang () {   // 0中文，1英文
            return this.$store.state.lang
        }
    },
    methods: {
        onLineAnimIteration () {
            this.timelineIndex = (this.timelineIndex + 1) % this.text.timeline.length
        },
        onLineAnimEnd2 () {
            this.midIndex2 = (this.midIndex2 + 1) % this.text.midpart2.length
        }
    },
    mounted () {
        // eslint-disable-next-line
        _hmt.push(['_trackEvent', '用户', '进入', '关于我们-概览'])
        const url = location.href
        var shareInfo = {
            title: '为客户提供增长落地方案',
            desc: 'Deansel专注于解决客户在新生态下的增长方案'
        }
        wxShare(url, shareInfo)
        var lineAnim = document.getElementById('line_anim')
        lineAnim.addEventListener('animationiteration', this.onLineAnimIteration, false)
        lineAnim.addEventListener('webkitAnimationIteration', this.onLineAnimIteration, false)
        var lineAnim2 = []
        this.text.midpart2.forEach((item, index) => {
            lineAnim2[index] = document.getElementById('line2_anim_' + index)
            lineAnim2[index].addEventListener('animationend', this.onLineAnimEnd2, false)
            lineAnim2[index].addEventListener('webkitAnimationEnd', this.onLineAnimEnd2, false)
        })
        
    }
}
</script>

<style scoped>
.top {
    width: 100%;
    height: 100vh;
    background: linear-gradient(0.02turn, #444C71, #B6ADB4);
    position: relative;
    text-align: left;
}
.top_textbox {
    width: 86%;
    position: absolute;
    left: 7%;
    bottom: 20px;
    color: #fff;
}
.top_title {
    width: 70%;
    font-size: 2.25rem;
    font-weight: 500;
    margin-bottom: 10%;
}
.line_bg {
    width: 100%;
    height: 1px;
    background: rgba(255, 255, 255, 0.2);
}
.line_anim {
    background: rgba(255, 255, 255, 0.6);
    width: 100%;
    height: 100%;
    animation: 5s line-progress linear infinite;
}
@keyframes line-progress {
    0% {
        width: 0;
    }
    100% {
        width: 100%;
    }
}
.top_timeline {
    max-width: 80%;
    font-size: 0.875rem; 
    line-height: 2;
    margin-top: 20px;
    padding-left: 1rem;
}
.middle {
    display: flex;
    flex-direction: column;
    align-items: center;
}
.midlle_part {
    width: 80%;
    margin-top: 10%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.midlle_part:nth-child(2n) {
    flex-direction: row-reverse;
}
.midlle_part_img {
    width: 40vw;
    height: 46vw;
    background: #B6ADB4;
}
.midlle_part_img img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.middle_part_textbox {
    width: 34vw;
    text-align: left;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.middle_part_title {
    width: 100%;
    margin-bottom: 2vw;
    font-size: 1.125rem;
    font-weight: bold;
    line-height: 1.5;
}
.middle_part_content {
    width: 100%;
    color: #666;
    font-size: 0.875rem;
    line-height: 1.5;
}
.middle2 {
    width: 80vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-top: solid #A1A1A1 2px;
    border-bottom: solid #A1A1A1 2px;
    margin: 10vw 10vw 0 10vw;
}
.middle2_topbox {
    width: 80%;
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin: 10% auto;
}
.middle2_topitem {
    width: 24%;
    padding: 1rem auto;
    position: relative;
}
.middle2_title {
    width: 100%;
    font-size: 0.875rem;
    line-height: 1.5;
    text-align: center;
    margin-bottom: 10%;
}
.line2_box {
    width: 100%;
    height: 1px;
    position: relative;
    background: #D5D5D5;
}
.line2_anim {
    width: 100%;
    height: 1px;
    position: absolute;
    bottom: 0;
    left: 0;
    background: linear-gradient(90deg,#e9b47c,#5f81b0);
    animation: 2s line-progress2 linear;
}
@keyframes line-progress2 {
    0% {width: 0;};
    100% {width: 100%;};
}
.middle2_text {
    width: 80%;
    font-size: 1.875rem;
    line-height: 1.5;
    margin-bottom: 6%;
}
.middle2_button {
    font-size: 0.875rem;
    color: #000;
    border: #ccc 1px solid;
    padding: 0.5rem 1.5rem;
    margin-bottom: 8vw;
}
.middle2_button:hover {
    border: #32343B 1px solid;
}
@media screen and (max-width: 756px) {
    .midlle_part {
        justify-content: flex-start;
        flex-direction: column;
    }
    .midlle_part:nth-child(2n) {
        flex-direction: column;
    }
    .midlle_part_img {
        width: 100%;
        height: 50vw;
        margin-bottom: 3vw;
    }
    .middle_part_textbox {
        width: 100%;
    }
    .middle2_text {
        width: 100%;
    }
    .middle2_topbox {
        width: 100%;
    }
    .middle2_topitem {
        width: 30%;
    }
}
</style>
